import {
  PravoEuItem as PravoEuItemDto,
  PravoEuListApi,
  PravoEuListPage as PravoEuListPageDto,
  PravoEuFilter as PravoEuFilterDto,
  SortDirectionEnum,
} from 'pravo-eu-frontend-ts-axios';
import { PravoEuFilter } from '../model/PravoEuFilter';
import { ClientResponse } from '../model/ClientResponse';
import PravoEuListPage from '../model/PravoEuListPage';
import apiConfiguration from './configuration/apiConfiguration';
import { pravoEuPrefixPath } from './configuration/apiConfigurationConstants';
import PravoEuItem from '../model/PravoEuItem';
import stringToDate from '../function/stringToDate';
import dateToString from '../function/dateToString';

const client = new PravoEuListApi(apiConfiguration(pravoEuPrefixPath));

function mapPravoEu(predpis: PravoEuItemDto): PravoEuItem {
  return {
    celex: predpis.celex,
    nazov: predpis.nazov,
    datumUverejnenia: stringToDate(predpis.datumUverejnenia),
    typ: predpis.typ,
    uuid: predpis.uuid,
  };
}

function map(page: PravoEuListPageDto): PravoEuListPage {
  return {
    number: page.number,
    size: page.size,
    totalElements: page.totalElements,
    predpisList: page.predpisList.map(predpis => mapPravoEu(predpis)),
  };
}

function mapFilter(filter: PravoEuFilter): PravoEuFilterDto {
  return {
    hladanyVyraz: filter?.hladanyVyraz === '' ? undefined : filter.hladanyVyraz,
    celex: filter?.celex === '' ? undefined : filter?.celex,
    rokUverejnenia: filter?.rokUverejnenia,
    eurovoc: filter?.eurovoc === '' ? undefined : filter?.eurovoc,
    autorNazov: filter?.autor?.nazov,
    typNazov: filter?.type?.nazov,
    zmluva: filter?.zmluva === '' ? undefined : filter?.zmluva,
    datumUverejneniaOd: dateToString(filter?.datumUverejneniaOd),
    datumUverejneniaDo: dateToString(filter?.datumUverejneniaDo),
    datumSchvaleniaOd: dateToString(filter?.datumSchvaleniaOd),
    datumSchvaleniaDo: dateToString(filter?.datumSchvaleniaDo),
    datumUcinnostiOdOd: dateToString(filter?.datumUcinnostiOdOd),
    datumUcinnostiOdDo: dateToString(filter?.datumUcinnostiOdDo),
    datumUcinnostiDoOd: dateToString(filter?.datumUcinnostiDoOd),
    datumUcinnostiDoDo: dateToString(filter?.datumUcinnostiDoDo),
    datumUzavierkyOd: dateToString(filter?.datumUzavierkyOd),
    datumUzavierkyDo: dateToString(filter?.datumUzavierkyDo),
    datumTranspozicieOd: dateToString(filter?.datumTranspozicieOd),
    datumTranspozicieDo: dateToString(filter?.datumTranspozicieDo),
  };
}

export const fetchPravoEuList = async (
  filter: PravoEuFilter,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
): Promise<ClientResponse<PravoEuListPage>> => {
  const {
    data,
    status,
  } = await client.getPravoEuFilteredList(mapFilter(filter), page, size, sortBy, sortDirection);

  return ({
    data: map(data),
    responseCode: status,
  });
};
